import * as React from "react";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { projectsDataStore } from "Stores/ProjectsStore";
import { API_URL } from "General/APIEndpoints";
import { API } from "General/API";
import { OnlineViewerCompare } from "./Components/OnlineViewerCompare";
import { Loader } from "Components/General/Loader";

export interface OnlineViewerCompareDataLayerProps extends ModalComponentProps {
  fileToCompare: API_FileDataEntity;
}

export const OnlineViewerCompareDataLayer = (props: OnlineViewerCompareDataLayerProps) => {
  const [versions, setVersionsData] = React.useState<API_FileDataEntity[]>([]);
  const [loading, setLoading] = React.useState<boolean>(false);

  const fetchFileVersions = async () => {
    try {
      setLoading(true);
      const response = await API.getData<API_FileDataEntity[]>(
        API_URL.FILES.getVersionsInfo_1(projectsDataStore.projectId, props.fileToCompare.id)
      );
      setVersionsData(response);
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchFileVersions();
  }, [props.fileToCompare.id]);

  if (loading) {
    return <Loader />;
  }

  return <OnlineViewerCompare files={versions} hideModal={props.hideModal} fileToCompare={props.fileToCompare} />;
};
